import { EmptyState, Table } from '@backstage/core-components';
import { useAccountId } from '../hooks/useAccountId';
import { AllowedRepositories } from '../types';
import { Link, Typography, Divider, CardContent } from '@material-ui/core';

interface DeploymentRoleRepositoriesTableProps {
  allowedRepositories: AllowedRepositories[];
}

const CustomTable = ({ columns, data }: { columns: any; data: any }) => (
  <Table
    columns={columns}
    data={data}
    options={{
      showTitle: false,
      loadingType: 'linear',
      header: false,
      search: false,
      padding: 'dense',
      toolbar: false,
      paging: data.length > 5,
      pageSizeOptions: [5],
    }}
  />
);

export function DeploymentRoleRepositoriesTable({
  allowedRepositories,
}: DeploymentRoleRepositoriesTableProps) {
  const accountId = useAccountId();

  // TODO: Get these values from accounts api
  const roles = [
    {
      use: 'Deployment',
      arn: `arn:aws:iam::${accountId}:role/pfg/infra/pfg-oidc-cdk`,
    },
  ];

  const role_columns = [
    {
      title: 'Use',
      field: 'use',
      width: '20%',
    },
    {
      title: 'Role ARN',
      field: 'arn',
      width: '80%',
    },
  ];

  const repo_columns = [
    {
      title: 'Repository',
      field: 'slug',
      render: (row: { slug: string }) => (
        <Link href={`https://github.com/${row.slug}`}>{row.slug}</Link>
      ),
    },
  ];

  return allowedRepositories.length > 0 ? (
    <CardContent>
      <Typography variant="h6">Roles</Typography>
      <CustomTable columns={role_columns} data={roles} />
      <Divider style={{ margin: '16px 0' }} />
      <Typography variant="h6">Repositories</Typography>
      <CustomTable columns={repo_columns} data={allowedRepositories} />
    </CardContent>
  ) : (
    <CardContent>
      <EmptyState title="No current configuration" missing="data" />
    </CardContent>
  );
}
